<template>
  <div :class="['toolbar-button', isH5 ? 'toolbar-button-h5' : '']" @click="onClick">
    <Icon v-if="props.icon" class="toolbar-button-icon" :file="props.icon" width="14px" height="14px"/>
    <div class="toolbar-button-text">
      {{ props.title || TUITranslateService.t('AIDesk.服务评价') }}
    </div>
  </div>
</template>
<script lang="ts">
import vue from '../../../adapter-vue';
import { isH5 } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import { TUITranslateService, TUIChatService, IConversationModel, StoreName, TUIStore } from '../../../@aidesk/uikit-engine';
import { CUSTOM_MESSAGE_SRC } from '../../../constant';
import { isEnabledMessageReadReceiptGlobal, getTo, debounce } from '../../../utils/utils';
interface IProps {
  title?: string;
  icon?: string | undefined;
}
const __sfc_main = {};
__sfc_main.props = {
  title: {
    key: "title",
    required: false,
    type: String,
    default: ''
  },
  icon: {
    key: "icon",
    required: false,
    type: [String, null],
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    onMounted,
    onUnmounted
  } = vue;
  const currentConversation = ref<IConversationModel>();
  const props = __props;
  const emits = __ctx.emit;
  onMounted(() => {
    TUIStore.watch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
  });
  onUnmounted(() => {
    TUIStore.unwatch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
  });
  const onCurrentConversationUpdate = (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  };
  const onClick = debounce(() => {
    if (!currentConversation.value) {
      return;
    }
    TUIChatService.sendCustomMessage({
      to: getTo(currentConversation.value),
      conversationType: currentConversation.value.type,
      payload: {
        data: JSON.stringify({
          src: CUSTOM_MESSAGE_SRC.USER_SATISFACTION,
          customerServicePlugin: 0
        })
      },
      needReadReceipt: isEnabledMessageReadReceiptGlobal()
    }, {
      onlineUserOnly: true
    }).finally(() => {
      emits('closePopover');
    });
  }, 300);
  return {
    isH5,
    TUITranslateService,
    props,
    onClick
  };
};
__sfc_main.components = Object.assign({
  Icon
}, __sfc_main.components);
export default __sfc_main;
</script>
<style></style>
